export default "__VITE_ASSET__96IL4D0n__"